import {SettingsTab} from '../../types';

export const tabItems = {
	general: [
		{
			value: SettingsTab.SystemSettings,
			name: 'System Settings',
		},
		// TODO: The next tab should be uncommented when the tab is ready to be deployed
		// {
		// 	value: SettingsTab.LanguagesAndTemplates,
		// 	name: 'Languages & Templates',
		// },
		// TODO: The next tab should be uncommented when the tab is ready to be deployed
		// {
		// 	value: SettingsTab.GradeScales,
		// 	name: 'Grade Scales',
		// },
	],

	testing: [
		{
			value: SettingsTab.KeyboardShortcuts,
			name: 'Keyboard Shortcuts',
		},
		{
			value: SettingsTab.TestButtonLabels,
			name: 'Test Button Labels',
		},
		{
			value: SettingsTab.StudentTestingOptions,
			name: 'Student Testing Options',
		},
	],

	testSessionResults: [
		{
			value: SettingsTab.TestResultVerbiage,
			name: 'Test Result Verbiage',
		},
		{
			value: SettingsTab.TestSessionResults,
			name: 'Test Session Results',
		},
	],
};
